import React, { useState } from 'react';
import { AiOutlineDownload } from 'react-icons/ai';
import Swal from 'sweetalert2'; // Import SweetAlert
import * as XLSX from 'xlsx';
import { Backdrop, Button, Dialog, DialogContent } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress'; // Import CircularProgress from Material-UI

import { useFilter } from '../layouts/dashboard/FilterProvider';
import apiFunctions from '../API/api';

const LuckyMeterReport = () => {
  const { filter } = useFilter();

  const [loading, setLoading] = useState(false);
  const Popup = () => {
    Swal.fire({
      title: 'Download Report',
      text: 'Do you want to download the report?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, download it!',
      cancelButtonText: 'No, cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        handleDownload();
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        // User clicked "No, cancel"
        Swal.fire('Cancelled', 'The download request was cancelled.', 'info');
      }
    });
  };

  const handleDownload = async () => {
    try {
      setLoading(true);
      const data = await apiFunctions.getExcelData(filter);
      console.log('report', data);
      // const store = await apiFunctions.getStoreCounts();

      // response.data; // Replace with the data from your API

      // Convert data to worksheet
      console.log(data, 'data');
      //   console.log(store1, 'store1');
      //   console.log(locationSheet, 'locationSheet');
      const worksheet1 = XLSX.utils.json_to_sheet(data[0]); // removed {header: columns} after, data

      // Create a new workbook and add the worksheet to it
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet1, 'User Details');

      // Generate a binary string from the workbook
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      setLoading(false);
      Swal.fire({
        icon: 'info',
        title: 'Download Started',
        text: 'Your download has started.',
        showConfirmButton: false, // Prevent the user from closing it manually
      });

      // Create a Blob from the buffer and download the file
      const blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;

      a.download = 'Lucky_Meter_Report.xlsx';
      a.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      setLoading(false);
      console.error('Error downloading Excel:', error);
    }
  };

  return (
    <div>
      <Button onClick={Popup} style={{ color: '#D24A61', height: '40px' }}>
        <AiOutlineDownload style={{ width: 'auto', height: '22px' }} /> &#160; Download Report
      </Button>

      <Dialog open={loading} maxWidth="false">
        <DialogContent style={{ background: 'white', padding: '20px' }}>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <CircularProgress style={{ color: '#D24A61' }} size={60} thickness={4} />{' '}
            {/* Display the loader when loading is true */}
          </div>
          <br />
          Generating Report...
        </DialogContent>
      </Dialog>
      <Backdrop open={loading} />
    </div>
  );
};
export default LuckyMeterReport;
